<!--
    @deprecated desde 2026-07 — usar <Button :loading="true" />
    Conservado durante la migración. Será eliminado al cerrar Fase 6.
-->
<template>
    <button :disabled="loading" :class="[loading ? 'opacity-70 cursor-not-allowed' : 'hover:shadow-lg hover:shadow-indigo-200/40 hover:-translate-y-0.5 active:translate-y-0']" class="btn-primary inline-flex items-center px-5 py-2.5 text-white rounded-xl font-medium transition-all duration-200">
        <svg v-if="loading" class="w-4 h-4 mr-2 animate-spin" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
        </svg>
        <svg v-else class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/></svg>
        {{ loading ? loadingText : text }}
    </button>
</template>
<script>
export default {
    props: {
        loading: { type: Boolean, default: false },
        text: { type: String, default: 'Guardar' },
        loadingText: { type: String, default: 'Guardando...' },
    },
};
</script>
